import React, { useEffect } from 'react'

export default function ErrorPage(props) {

  useEffect(() => {
    //document.title = props.titulo;
  }, [props.titulo])

  return (
    <div>Sitio no encontrado</div>
  )
}
